import COUNTRIES from '../countries.translations'

import translations from './silver.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/silver'

export const silver: Metal = {
  id: 21,
  slug: 'silver',
  name: t.name,
  symbol: 'Ag',
  mines: [
    {
      name: "Fresnillo (Mexico, Fresnillo PLC, Zacatecas — world's largest primary silver mine)",
      region: t.mine0Region,
      slug: 'fresnillo',
      coordinates: [-102.87, 23.17],
    },
    {
      name: 'Peñasquito (Mexico, Newmont)',
      region: t.mine1Region,
      slug: 'penasquito',
      coordinates: [-102.35, 23.9],
    },
    {
      name: 'Antamina (Peru)',
      region: t.mine2Region,
      slug: 'antamina',
      coordinates: [-77.06, -9.53],
    },
    {
      name: "Cerro Rico/Potosí (Bolivia — historically the world's richest silver deposit)",
      region: t.mine3Region,
      slug: 'cerro-rico-potosi',
      coordinates: [-65.75, -19.58],
    },
    {
      name: 'Cannington (Australia, South32)',
      region: t.mine4Region,
      slug: 'cannington',
      coordinates: [140.27, -22.55],
    },
  ],
  countries: [
    { name: COUNTRIES.mexico, percent: 25.2 },
    { name: COUNTRIES.china, percent: 13.2 },
    { name: COUNTRIES.peru, percent: 12.4 },
    { name: COUNTRIES.poland, percent: 5.2 },
    { name: COUNTRIES.bolivia, percent: 5.2 },
  ],
  // Mostly recovered as a by-product of lead, zinc, copper or gold mining.
  related: ['lead', 'zinc', 'copper', 'gold'],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 3, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 1, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/03.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
